import { quotes } from "./Quotes";
import { vendors } from "../pricingService/vendors";
import { quoteAttachments } from "./quoteAttachments";
export const pricingService = {
  quotes,
  vendors,
  quoteAttachments,
};
